import { createTheme } from "@mui/material/styles";
import { hover } from "@testing-library/user-event/dist/hover";
import {defaultTheme as componentTheme} from "@awc/components/src/DefaultTheme"
import { BaseColors as componentBaseColors} from "@awc/components/src/DefaultTheme";

export const BaseColors = componentBaseColors;
export const defaultTheme = componentTheme;
